import React, { useState } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Grid,
  Fade,
  useTheme,
  useMediaQuery
} from "@mui/material";
import ICDLTest from "./ICDLTest";
import ManagementTest from "./ManagementTest";
import Lwas from "./Lwas";

export default function ExamsHome() {
  const [selectedExam, setSelectedExam] = useState(null);

  // Responsive check
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (selectedExam === "icdl") return <ICDLTest />;
  if (selectedExam === "mgmt") return <ManagementTest />;
  if (selectedExam === "law") return <Lwas />;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(120deg, #f5fafd 0%, #e8eafc 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Cairo",
        py: 4
      }}
    >
      <Fade in timeout={900}>
        <Box
          sx={{
            width: "100%",
            maxWidth: 900,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 0,
            pt: isMobile ? 4 : 0
          }}
        >
          <Typography
            variant={isMobile ? "h5" : "h3"}
            fontWeight="bold"
            sx={{
              fontFamily: "Cairo",
              color: "#194176",
              mb: 2,
              letterSpacing: 0.5,
              textAlign: "center",
              lineHeight: 1.2,
              textShadow: "0 2px 12px #4a587680"
            }}
          >
            اختر الاختبار المناسب لك
          </Typography>
          <Box
            sx={{
              width: 60,
              height: 6,
              background: "linear-gradient(90deg, #1976d2 30%, #ffd600 80%)",
              borderRadius: 10,
              mb: 6,
              boxShadow: "0 2px 12px #1976d244"
            }}
          />
          <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="center"
            sx={{
              width: "100%",
              maxWidth: 900,
              px: isMobile ? 2 : 0
            }}
          >
            {/* ICDL Test Card */}
            <Fade in timeout={1300}>
              <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center">
                <Card
                  sx={{
                    minWidth: 280,
                    minHeight: 240,
                    maxWidth: 350,
                    mx: "auto",
                    borderRadius: 6,
                    boxShadow: "0 4px 28px 0 #1976d222, 0 1.5px 3px 0 #0001",
                    transition: "transform 0.22s cubic-bezier(.32,2,.55,.27), box-shadow 0.25s",
                    position: "relative",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "scale(1.045) translateY(-8px)",
                      boxShadow: "0 12px 40px 0 #1976d299, 0 2px 6px 0 #0002"
                    }
                  }}
                  onClick={() => setSelectedExam("icdl")}
                >
                  <CardActionArea sx={{ height: "100%" }}>
                    <CardContent
                      sx={{
                        textAlign: "center",
                        px: 3,
                        pt: 5,
                        pb: 4
                      }}
                    >
                      <span style={{ fontSize: 50, display: "block", marginBottom: 10 }}>
                        💻
                      </span>
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        sx={{
                          fontFamily: "Cairo",
                          color: "#1976d2"
                        }}
                      >
                        اختبار الحاسب الآلي
                      </Typography>
                      <Typography
                        sx={{
                          mt: 2,
                          color: "#495366",
                          fontFamily: "Cairo",
                          fontSize: 18,
                          fontWeight: 400
                        }}
                      >
                        اختبار اختياري + عملي في مهارات الحاسب الآلي (ICDL)
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Fade>

            {/* Management Test Card */}
            <Fade in timeout={1700}>
              <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center">
                <Card
                  sx={{
                    minWidth: 280,
                    minHeight: 240,
                    maxWidth: 350,
                    mx: "auto",
                    borderRadius: 6,
                    boxShadow: "0 4px 28px 0 #ffd60040, 0 1.5px 3px 0 #0001",
                    transition: "transform 0.22s cubic-bezier(.32,2,.55,.27), box-shadow 0.25s",
                    position: "relative",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "scale(1.045) translateY(-8px)",
                      boxShadow: "0 12px 40px 0 #ffd600bb, 0 2px 6px 0 #0002"
                    }
                  }}
                  onClick={() => setSelectedExam("mgmt")}
                >
                  <CardActionArea sx={{ height: "100%" }}>
                    <CardContent
                      sx={{
                        textAlign: "center",
                        px: 3,
                        pt: 5,
                        pb: 4
                      }}
                    >
                      <span style={{ fontSize: 50, display: "block", marginBottom: 10 }}>
                        🏢
                      </span>
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        sx={{
                          fontFamily: "Cairo",
                          color: "#ffb300"
                        }}
                      >
                        اختبار الإدارة
                      </Typography>
                      <Typography
                        sx={{
                          mt: 2,
                          color: "#495366",
                          fontFamily: "Cairo",
                          fontSize: 18,
                          fontWeight: 400
                        }}
                      >
                        اختبار في مفاهيم الإدارة والقيادة الإدارية
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Fade>

            {/* Law Test Card */}
            <Fade in timeout={2100}>
              <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center">
                <Card
                  sx={{
                    minWidth: 280,
                    minHeight: 240,
                    maxWidth: 350,
                    mx: "auto",
                    borderRadius: 6,
                    boxShadow: "0 4px 28px 0 #9c27b040, 0 1.5px 3px 0 #0001",
                    transition: "transform 0.22s cubic-bezier(.32,2,.55,.27), box-shadow 0.25s",
                    position: "relative",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "scale(1.045) translateY(-8px)",
                      boxShadow: "0 12px 40px 0 #9c27b099, 0 2px 6px 0 #0002"
                    }
                  }}
                  onClick={() => setSelectedExam("law")}
                >
                  <CardActionArea sx={{ height: "100%" }}>
                    <CardContent
                      sx={{
                        textAlign: "center",
                        px: 3,
                        pt: 5,
                        pb: 4
                      }}
                    >
                      <span style={{ fontSize: 50, display: "block", marginBottom: 10 }}>
                        ⚖️
                      </span>
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        sx={{
                          fontFamily: "Cairo",
                          color: "#9c27b0"
                        }}
                      >
                        اختبار القانون
                      </Typography>
                      <Typography
                        sx={{
                          mt: 2,
                          color: "#495366",
                          fontFamily: "Cairo",
                          fontSize: 18,
                          fontWeight: 400
                        }}
                      >
                        اختبار في المبادئ القانونية والنظم التشريعية
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Fade>
          </Grid>
        </Box>
      </Fade>
    </Box>
  );
}